import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

type QRType = 'url' | 'phone' | 'message';

@Component({
  selector: 'app-qr-generator-tests',
  templateUrl: './qr-generator-tests.component.html',
  styleUrls: ['./qr-generator-tests.component.scss']
})
export class QRGeneratorTestsComponent {
  public qrType: QRType = 'url';
  public qrValue = 'https://bendigo-pc-clinic.example/qr-test';
  public messageBody = '';
  public qrSize = 400;
  public errorCorrectionLevel: 'L' | 'M' | 'Q' | 'H' = 'L';
  public generatedValue = '';
  public qrCodeDownloadUrl: SafeUrl | null = null;
  public status: 'idle' | 'ready' | 'error' = 'idle';
  public message = 'Enter a value and generate a QR code.';

  get qrRenderSize(): number {
    return Math.max(80, Math.min(this.qrSize || 400, 640));
  }

  get qrValueLabel(): string {
    return this.qrType === 'phone' || this.qrType === 'message' ? 'Phone number' : 'URL';
  }

  get qrValuePlaceholder(): string {
    return this.qrType === 'phone' || this.qrType === 'message'
      ? 'e.g. 0354412345 or +61354412345'
      : 'https://example.com';
  }

  onQRTypeChange(): void {
    this.generatedValue = '';
    this.qrCodeDownloadUrl = null;
    this.status = 'idle';
    if (this.qrType === 'phone') {
      this.message = 'Enter a phone number and generate a tel: QR code.';
      return;
    }

    if (this.qrType === 'message') {
      this.message = 'Enter a phone number and message body to generate an sms: QR code.';
      return;
    }

    this.message = 'Enter a URL and generate a QR code.';
  }

  generateQRCode(): void {
    const value = (this.qrValue || '').trim();
    if (!value) {
      this.generatedValue = '';
      this.qrCodeDownloadUrl = null;
      this.status = 'error';
      this.message = `${this.qrValueLabel} is required.`;
      return;
    }

    const payload = this.buildQRPayload(value);
    if (!payload) {
      this.generatedValue = '';
      this.qrCodeDownloadUrl = null;
      this.status = 'error';
      this.message = `Enter a valid ${this.qrValueLabel.toLowerCase()}.`;
      return;
    }

    this.generatedValue = payload;
    this.qrCodeDownloadUrl = null;
    this.status = 'ready';
    this.message = 'QR code generated in browser.';
  }

  onQRCodeURL(url: SafeUrl): void {
    this.qrCodeDownloadUrl = url;
  }

  private buildQRPayload(value: string): string {
    if (this.qrType === 'phone') {
      const phone = value.replace(/[^\d+]/g, '');
      if (!phone || phone === '+') {
        return '';
      }

      return `tel:${phone}`;
    }

    if (this.qrType === 'message') {
      const phone = value.replace(/[^\d+]/g, '');
      if (!phone || phone === '+') {
        return '';
      }

      const body = (this.messageBody || '').trim();
      return body ? `sms:${phone}?body=${encodeURIComponent(body)}` : `sms:${phone}`;
    }

    return value;
  }
}
